import React from 'react';
import PropTypes from 'prop-types';

const DownloadButton = ({
    onClick,
    loading = false,
    progress = 0,
    children = "Descargar Excel",
    className = "btn btn-primary w-100"
}) => {
    return (
        <button
            className={className}
            onClick={onClick}
            disabled={loading}
            style={{
                position: 'relative',
                minWidth: '150px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
            }}
        >
            {loading ? (
                <React.Fragment>
                    <div
                        style={{
                            width: '20px',
                            height: '20px',
                            border: '3px solid rgba(255, 255, 255, 0.3)',
                            borderTop: '3px solid white',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }}
                    />
                    <span style={{ color: 'white', fontSize: '14px' }}>
                        {progress > 0 ? `${Math.round(progress)}%` : 'Descargando...'}
                    </span>
                    <style>
                        {`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}
                    </style>
                </React.Fragment>
            ) : (
                children
            )}
        </button>
    );
};

DownloadButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    progress: PropTypes.number,
    children: PropTypes.node,
    className: PropTypes.string
};

export default DownloadButton;
